import { css } from "@emotion/react"
import { Icon } from "source/shared/components"
import { DonationType } from "../../types"
import { Fund } from "source/giving/donate/form/types"

export default function BlankState({
  donationType,
  activeYear,
  activeFund,
}: {
  donationType: DonationType
  activeYear: number | null
  activeFund: Fund | null
}) {
  const donationTypeLabel = donationType === "monetary" ? "monetary" : "in-kind"
  return (
    <div className="ta-c c-tint3 p-4">
      <Icon
        symbol={`churchCenter#${donationType === "monetary" ? "giving-o" : "giving-in-kind-o"}`}
        css={css`
          width: 36px;
          height: 36px;
          margin-bottom: 0.5rem;
        `}
      />
      {activeYear ? (
        activeFund ? (
          <p>
            You don&apos;t have any {donationTypeLabel} donations to{" "}
            {activeFund.name} in {activeYear}
          </p>
        ) : (
          <p>
            You don&apos;t have any {donationTypeLabel} donations in{" "}
            {activeYear}
          </p>
        )
      ) : (
        <p>You haven&apos;t made any {donationTypeLabel} donations</p>
      )}
    </div>
  )
}
